const prefix = "?";

const commands = [
  {
    command: `${prefix}fishadd | fa`,
    desc: "Increments your fish counter (optionally attach an image when sending)."
  },
  {
    command: `${prefix}fishremove [ID] | fr [ID]`,
    desc: "Removes a fish when provided an ID."
  },
  {
    command: `${prefix}fish [ID]`,
    desc: "Displays the fish when provided an ID."
  },
  {
    command: `${prefix}fishlist | fl`,
    desc: "Displays a list of all the fish you've caught."
  },
  {
    command: `${prefix}fishlistall | fla`,
    desc: "Displays a list of all the fish caught in the server."
  },
  {
    command: `${prefix}lostlureadd | lla`,
    desc: "Increments your lost lure counter."
  },
  {
    command: `${prefix}lostlureremove | llr`,
    desc: "Decrements your lost lure counter."
  },
  {
    command: `${prefix}lostlureleaderboards | lll`,
    desc: "Displays the lost lure leaderboards."
  },
  {
    command: `${prefix}leaderboards | l`,
    desc: "Displays the leaderboards."
  },
  {
    command: `${prefix}profile`,
    desc: "Displays your fishing profile."
  } 
];

export default commands;